import { AutoFilterBreezeListComponent } from '@common/classes/auto-filter-list';
import { InvoiceStatusCodes } from '@common/classes/codes';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { DialogService } from '@common/services/dialog.service';
import { SharedService } from '@common/services/shared.service';
import _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@common/services/shared.service";
import * as i3 from "@common/services/dialog.service";
import * as i4 from "@angular/common";
import * as i5 from "@angular/router";
import * as i6 from "@angular/forms";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "@fortawesome/angular-fontawesome";
import * as i9 from "@progress/kendo-angular-grid";
import * as i10 from "../../../common/components/action-bar/action-bar.component";
import * as i11 from "../../../common/components/app-control/app-control.component";
import * as i12 from "../../../common/components/app-form/app-form.component";
import * as i13 from "../../../common/components/content-header/content-header.component";
import * as i14 from "../../../common/components/app-grid/app-grid.component";
import * as i15 from "../../../common/components/app-control-container/app-control-container.component";
import * as i16 from "../../../common/components/accordion-header.component";
import * as i17 from "@ngx-translate/core";
function InvoiceApprovalListComponent_ng_template_6_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r4.numberOfActiveFilters, ")");
  }
}
function InvoiceApprovalListComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-accordion-header", 26);
    i0.ɵɵlistener("panelChange", function InvoiceApprovalListComponent_ng_template_6_Template_app_accordion_header_panelChange_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.handleFilterHighlighter(true));
    });
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵelement(2, "fa-icon", 27);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, InvoiceApprovalListComponent_ng_template_6_span_5_Template, 2, 1, "span", 28);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const panel_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("panel", panel_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(4, 3, "Filters"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.numberOfActiveFilters > 0);
  }
}
function InvoiceApprovalListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-form", 29);
    i0.ɵɵlistener("submit", function InvoiceApprovalListComponent_ng_template_7_Template_app_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext();
      ctx_r8.search();
      return i0.ɵɵresetView(ctx_r8.onAutoFilterChange());
    });
    i0.ɵɵelementStart(1, "app-control-container", null, 30)(3, "div", 8)(4, "div", 31)(5, "app-control", 32);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.filter.signedById = $event);
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 31)(8, "app-control", 33);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.filter.statusId = $event);
    });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 31)(11, "app-control", 34);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.filter.createdDateFrom = $event);
    });
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 31)(14, "app-control", 35);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.filter.createdDateTo = $event);
    });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 31)(17, "app-control", 36);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_17_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.filter.issuedDateFrom = $event);
    });
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 31)(20, "app-control", 37);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_20_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.filter.issuedDateTo = $event);
    });
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 31)(23, "app-control", 38);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_23_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.filter.exchangeRateDateFrom = $event);
    });
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "div", 31)(26, "app-control", 39);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_26_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.filter.exchangeRateDateTo = $event);
    });
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 31)(29, "app-control", 40);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_29_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.filter.customerId = $event);
    });
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 31)(32, "app-control", 41);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_32_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.filter.payerId = $event);
    });
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 31)(35, "app-control", 42);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_35_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.filter.invoiceNumber = $event);
    });
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(37, "div", 31)(38, "app-control", 43);
    i0.ɵɵlistener("ngModelChange", function InvoiceApprovalListComponent_ng_template_7_Template_app_control_ngModelChange_38_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.filter.mineInvoices = $event);
    });
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(40, "div", 44)(41, "div", 9)(42, "div", 45)(43, "button", 46);
    i0.ɵɵlistener("click", function InvoiceApprovalListComponent_ng_template_7_Template_button_click_43_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.clearFilter());
    });
    i0.ɵɵelement(44, "fa-icon", 47);
    i0.ɵɵtext(45, " \u00A0 ");
    i0.ɵɵelementStart(46, "span", 48);
    i0.ɵɵtext(47);
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(49, "button", 49);
    i0.ɵɵlistener("click", function InvoiceApprovalListComponent_ng_template_7_Template_button_click_49_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.search());
    });
    i0.ɵɵelement(50, "fa-icon", 50);
    i0.ɵɵtext(51, " \u00A0 ");
    i0.ɵɵelementStart(52, "span", 48);
    i0.ɵɵtext(53);
    i0.ɵɵpipe(54, "translate");
    i0.ɵɵelementEnd()()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 39, "Approved By"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.signedById)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(9, 41, "Invoice Status"));
    i0.ɵɵproperty("filter", ctx_r1.invoiceStatusFilter)("ngModel", ctx_r1.filter.statusId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(12, 43, "Created Date From"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.createdDateFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(15, 45, "Created Date To"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.createdDateTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(18, 47, "Issued Date From"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.issuedDateFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(21, 49, "Issued Date To"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.issuedDateTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(24, 51, "Exchange Rate Date From"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.exchangeRateDateFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(27, 53, "Exchange Rate Date To"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.exchangeRateDateTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(30, 55, "Customer"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.customerId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(33, 57, "Payer"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.payerId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(36, 59, "Invoice Number"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.invoiceNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(39, 61, "My Invoices"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.mineInvoices)("entity", ctx_r1.filter);
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(48, 63, "Clear"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(54, 65, "Search"));
  }
}
const _c0 = function (a1) {
  return ["/invoice/view", a1];
};
function InvoiceApprovalListComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 51);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r24 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0, row_r24.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r24.invoiceNumber, " ");
  }
}
const _c1 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
const _c2 = function () {
  return {
    "text-align": "right"
  };
};
export class InvoiceApprovalListComponent extends AutoFilterBreezeListComponent {
  constructor(breezeViewService, sharedService, dialogService) {
    super(breezeViewService, sharedService, null, dialogService);
    this.breezeViewService = breezeViewService;
    this.sharedService = sharedService;
    this.dialogService = dialogService;
    this.queryName = 'approvalInvoices';
    this.parentRoute = '/invoice/';
    this.excelCommand = 'ExportApprovalInvoiceToExcel';
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get('Invoices')
    }];
    this.invoiceStatusFilter = entity => _.includes([InvoiceStatusCodes.WaitingForApproval, InvoiceStatusCodes.Approved, InvoiceStatusCodes.Rejected], entity.id);
    this.actionBar[0].items = [{
      label: () => this.translateService.instant('Approve'),
      icon: 'check',
      onClick: () => {
        const data = {};
        let invoicesCount;
        if (_.isEmpty(this.selection)) {
          data.query = this.breezeService.convertToDto(this.filter);
          invoicesCount = this.appGrid.internalData.total;
        } else {
          data.ids = this.selection;
          invoicesCount = this.selection.length;
        }
        this.dialogService.confirm(this.translateService.instant('Approve'), `${this.translateService.instant(`Are you sure you want to approve invoices`)}(${invoicesCount})?`).then(result => {
          if (result === true) {
            return this.breezeViewService.handleCommand('ApproveInvoicesForApproval', data);
          }
        });
      }
    }, {
      label: () => this.translateService.instant('Reject'),
      icon: 'times',
      onClick: () => {
        const data = {};
        let invoicesCount;
        if (_.isEmpty(this.selection)) {
          data.query = this.breezeService.convertToDto(this.filter);
          invoicesCount = this.appGrid.internalData.total;
        } else {
          data.ids = this.selection;
          invoicesCount = this.selection.length;
        }
        this.dialogService.confirm(this.translateService.instant('Reject'), `${this.translateService.instant(`Are you sure you want to reject invoices`)}(${invoicesCount})?`).then(result => {
          if (result === true) {
            return this.breezeViewService.handleCommand('RejectInvoicesForApproval', data);
          }
        });
      }
    }];
  }
  getDefaultFilter(data) {
    return this.breezeViewService.entityManager.createEntity('GetApprovalInvoicesQuery', {
      statusId: InvoiceStatusCodes.WaitingForApproval,
      ...data
    });
  }
}
InvoiceApprovalListComponent.ɵfac = function InvoiceApprovalListComponent_Factory(t) {
  return new (t || InvoiceApprovalListComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.SharedService), i0.ɵɵdirectiveInject(i3.DialogService));
};
InvoiceApprovalListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: InvoiceApprovalListComponent,
  selectors: [["app-invoice-approval-list"]],
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 41,
  vars: 53,
  consts: [[3, "items"], [3, "title", "breadcrumb"], [1, "filter-wrapper"], ["activeIds", "ngb-panel-0"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "card", "card-border-top", "mt-3"], [1, "card-body"], [1, "row"], [1, "col"], [1, "mb-2", 3, "data", "sortable", "selectable", "selection", "selectionChange"], ["showSelectAll", "true", 3, "width"], ["field", "status.translatedId", 3, "title"], ["field", "type.translatedId", 3, "title"], ["field", "invoiceNumber", 3, "title"], ["kendoGridCellTemplate", ""], ["field", "customer.name", 3, "title"], ["field", "payer.name", 3, "title"], ["field", "recipient.name", 3, "title"], ["field", "finalCustomer.name", 3, "title"], ["field", "totalAmount", "format", "n2", 3, "title"], ["field", "currency.id", 3, "title"], ["field", "dueDays", 3, "title"], ["field", "dueDate", "format", "d", 3, "title"], ["field", "serviceDate", "format", "d", 3, "title"], ["field", "createdBy.fullName", 3, "title"], [3, "panel", "panelChange"], ["icon", "filter"], [4, "ngIf"], [3, "submit"], ["filterHighlighter", ""], [1, "col-3"], ["type", "codelist", "codelist", "User", "property", "signedById", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "InvoiceStatus", "property", "statusId", 3, "label", "filter", "ngModel", "entity", "ngModelChange"], ["property", "createdDateFrom", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "createdDateTo", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "issuedDateFrom", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "issuedDateTo", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "exchangeRateDateFrom", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "exchangeRateDateTo", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Customer", "property", "customerId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Customer", "property", "payerId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "invoiceNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "mineInvoices", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "row", "mt-3"], [1, "float-right"], [1, "btn", "btn-sm", "btn-danger", "mr-2", 3, "click"], ["icon", "trash", 1, "ml-1"], [1, "btn-text"], [1, "btn", "btn-sm", "btn-primary", 3, "click"], ["icon", "search", 1, "ml-1"], [1, "text-primary", 3, "routerLink"]],
  template: function InvoiceApprovalListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelement(0, "app-action-bar", 0)(1, "app-content-header", 1);
      i0.ɵɵpipe(2, "translate");
      i0.ɵɵelementStart(3, "div", 2)(4, "ngb-accordion", 3)(5, "ngb-panel");
      i0.ɵɵtemplate(6, InvoiceApprovalListComponent_ng_template_6_Template, 6, 5, "ng-template", 4);
      i0.ɵɵtemplate(7, InvoiceApprovalListComponent_ng_template_7_Template, 55, 67, "ng-template", 5);
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "div", 8)(11, "div", 9)(12, "app-grid", 10);
      i0.ɵɵlistener("selectionChange", function InvoiceApprovalListComponent_Template_app_grid_selectionChange_12_listener($event) {
        return ctx.selection = $event;
      });
      i0.ɵɵelement(13, "kendo-grid-checkbox-column", 11)(14, "kendo-grid-column", 12);
      i0.ɵɵpipe(15, "translate");
      i0.ɵɵelement(16, "kendo-grid-column", 13);
      i0.ɵɵpipe(17, "translate");
      i0.ɵɵelementStart(18, "kendo-grid-column", 14);
      i0.ɵɵpipe(19, "translate");
      i0.ɵɵtemplate(20, InvoiceApprovalListComponent_ng_template_20_Template, 2, 4, "ng-template", 15);
      i0.ɵɵelementEnd();
      i0.ɵɵelement(21, "kendo-grid-column", 16);
      i0.ɵɵpipe(22, "translate");
      i0.ɵɵelement(23, "kendo-grid-column", 17);
      i0.ɵɵpipe(24, "translate");
      i0.ɵɵelement(25, "kendo-grid-column", 18);
      i0.ɵɵpipe(26, "translate");
      i0.ɵɵelement(27, "kendo-grid-column", 19);
      i0.ɵɵpipe(28, "translate");
      i0.ɵɵelement(29, "kendo-grid-column", 20);
      i0.ɵɵpipe(30, "translate");
      i0.ɵɵelement(31, "kendo-grid-column", 21);
      i0.ɵɵpipe(32, "translate");
      i0.ɵɵelement(33, "kendo-grid-column", 22);
      i0.ɵɵpipe(34, "translate");
      i0.ɵɵelement(35, "kendo-grid-column", 23);
      i0.ɵɵpipe(36, "translate");
      i0.ɵɵelement(37, "kendo-grid-column", 24);
      i0.ɵɵpipe(38, "translate");
      i0.ɵɵelement(39, "kendo-grid-column", 25);
      i0.ɵɵpipe(40, "translate");
      i0.ɵɵelementEnd()()()()();
    }
    if (rf & 2) {
      i0.ɵɵproperty("items", ctx.actionBar);
      i0.ɵɵadvance(1);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 23, "Invoices For Approval"));
      i0.ɵɵproperty("breadcrumb", ctx.breadcrumb);
      i0.ɵɵadvance(11);
      i0.ɵɵproperty("data", ctx.query)("sortable", true)("selectable", i0.ɵɵpureFunction0(51, _c1))("selection", ctx.selection);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("width", 1);
      i0.ɵɵadvance(1);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(15, 25, "Invoice Status"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(17, 27, "Type"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(19, 29, "Invoice Number"));
      i0.ɵɵadvance(3);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(22, 31, "Customer"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(24, 33, "Payer"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(26, 35, "Recipient"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(28, 37, "Final Customer"));
      i0.ɵɵadvance(2);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(52, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(30, 39, "Amount"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(32, 41, "Currency"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(34, 43, "Payment Due Date"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(36, 45, "Account Due Date"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(38, 47, "Order Completed Date"));
      i0.ɵɵadvance(2);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(40, 49, "Created By"));
    }
  },
  dependencies: [i4.NgIf, i5.RouterLink, i6.NgControlStatus, i6.NgModel, i7.NgbAccordion, i7.NgbPanel, i7.NgbPanelContent, i7.NgbPanelHeader, i8.FaIconComponent, i9.ColumnComponent, i9.CheckboxColumnComponent, i9.CellTemplateDirective, i10.ActionBarComponent, i11.AppControlComponent, i12.AppFormComponent, i13.ContentHeaderComponent, i14.AppGridComponent, i15.AppControlContainerComponent, i16.AccordionHeaderComponent, i17.TranslatePipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});